<template>
  <v-card max-width="500" class="mx-auto">
    <v-toolbar color="indigo" dark>
      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-toolbar-title>Inbox</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-toolbar>
    <v-list>
      <v-list-item v-for="item in athletes" :key="item.node.athleteId">
        <v-list-item-icon>
          <v-icon> mdi-flag</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title
            v-text="
              item.node.firstName +
                ' ' +
                item.node.birthDate +
                '(' +
                ((new Date().getMonth() >
                new Date(item.node.birthDate).getMonth()
                  ? 1
                  : 0) +
                  new Date().getFullYear() -
                  new Date(item.node.birthDate).getFullYear()) +
                ')'
            "
          ></v-list-item-title>
          <!-- <v-list-item-subtitle v-text="item.node.birthDate"></v-list-item-subtitle> -->
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-skeleton-loader
      v-bind="attrs"
      type="card-avatar, article, actions"
    ></v-skeleton-loader>

    <v-skeleton-loader
      v-bind="attrs"
      type="article, actions"
    ></v-skeleton-loader>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      userEmail: "",
      attrs: "",
      newdate: "",
      date: new Date(),
      search$: null
    };
  },
  created() {
    this.handleGetAthleteList();
  },
  computed: {
    ...mapGetters(["loading", "error", "athleteList"]),

    athletes() {
      console.log(
        this.athleteList.edges.filter(
          itemNew => itemNew.node.status == "active"
        )
      );
      return this.athleteList.edges
        .filter(itemNew => itemNew.node.status == "active")
        .sort(
          (a, b) =>
            // new Date(b.node.birthDate) - new Date(a.node.birthDate));
            //Math.abs(Date.now() - new Date(b.node.birthDate).setFullYear(2020)) - Math.abs(Date.now() - new Date(a.node.birthDate).setFullYear(2020))

            // sort based on the nearest comming birthday
            new Date(a.node.birthDate).setFullYear(
              Date.now() >
                new Date(a.node.birthDate).setFullYear(new Date().getFullYear())
                ? 2021
                : 2020
            ) -
            new Date(b.node.birthDate).setFullYear(
              Date.now() >
                new Date(b.node.birthDate).setFullYear(new Date().getFullYear())
                ? 2021
                : 2020
            )
          //new Date(a.node.birthDate).setFullYear(2020) >
          ///new Date(b.node.birthDate).setFullYear(2020)
        );
      //return this.products.filter(item  => item.id == this. productId);
    }
  },

  watch: {},
  mounted() {},

  methods: {
    handleGetAthleteList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allAthlete", {
        clubId: "16"
      });
    }
  }
};
</script>

<style></style>
